import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 15000 });

export const fmtNumber = (n, options = {}) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-US", options).format(n);
};

export const fmtCurrency = (n, currency = "USD") => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  if (currency === "IDR") {
    return "Rp " + new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(n);
  }
  return "$" + new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(n);
};

export const fmtLargeNumber = (n) => {
  if (!n) return "—";
  if (n >= 1e12) return (n / 1e12).toFixed(2) + "T";
  if (n >= 1e9) return (n / 1e9).toFixed(2) + "B";
  if (n >= 1e6) return (n / 1e6).toFixed(2) + "M";
  return n.toString();
};

export default api;
